import { render, staticRenderFns } from "./OverdueTreatmentTable.vue?vue&type=template&id=2fe81dd0&"
import script from "./OverdueTreatmentTable.vue?vue&type=script&lang=js&"
export * from "./OverdueTreatmentTable.vue?vue&type=script&lang=js&"
import style0 from "./OverdueTreatmentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports